/** Mirrors backend/pricing.py – keep in sync. */
export const USES = ["meeting", "rehearsal", "celebration", "wedding", "event", "concert", "exhibition", "fair"];

export const USE_LABEL = {
  meeting: "Møte, kurs og foredrag",
  rehearsal: "Øving",
  celebration: "Feiring, dåp, konfirmasjon og minnestund",
  wedding: "Bryllaup",
  event: "Arrangement med publikum",
  concert: "Konsert med lyd og projektor",
  exhibition: "Utstilling",
  fair: "Salsmesse og marknad",
};

export const USE_SHORT = {
  meeting: "Møte/kurs",
  rehearsal: "Øving",
  celebration: "Feiring",
  wedding: "Bryllaup",
  event: "Arrangement",
  concert: "Konsert",
  exhibition: "Utstilling",
  fair: "Messe",
};

export const LINE_KINDS = [
  ["base", "Grunnpris", "Vanleg leige for eit brukstype"],
  ["addon", "Tillegg", "Kjem i tillegg til grunnprisen"],
  ["hourly", "Timepris", "Pris per time"],
  ["regular", "Faste brukarar", "Berre for lag med fast avtale"],
  ["closed", "Ikkje til leige", "Linja viser at rommet ikkje kan leigast til dette"],
];

export const KIND_LABEL = Object.fromEntries(LINE_KINDS.map(([k, l]) => [k, l]));
